module.exports = __webpack_public_path__ + "img/Policeman.b7f8838a.png";